import { useMemo, useState } from "react";
import { FEED_ITEMS, FEED_TABS } from "@/mocks/news";

export default function Feed() {
  const [tab, setTab] = useState("全部");
  const [visible, setVisible] = useState(6);

  const items = useMemo(() => {
    if (tab === "全部") return FEED_ITEMS;
    return FEED_ITEMS.filter((it) => it.category === tab);
  }, [tab]);

  const shown = items.slice(0, visible);

  return (
    <section id="latest" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              Latest Reports
            </p>
            <h3 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              最新爆料资讯
            </h3>
            <p className="mt-2 text-sm text-foreground-600">
              编辑部持续更新的线索跟进与热点报道，可按频道筛选浏览。
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2" role="tablist" aria-label="按频道筛选">
            {FEED_TABS.map((t) => (
              <button
                key={t}
                type="button"
                role="tab"
                aria-selected={tab === t}
                onClick={() => {
                  setTab(t);
                  setVisible(6);
                }}
                className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
                  tab === t
                    ? "bg-primary-500 text-background-50"
                    : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 lg:flex-row lg:gap-8">
          <div className="w-full divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            {shown.length === 0 && (
              <p className="p-8 text-center text-sm text-foreground-500">
                该频道暂无内容，欢迎通过投稿提供线索。
              </p>
            )}
            {shown.map((item) => (
              <article key={item.id} className="group p-4 transition-colors hover:bg-background-100 md:p-5">
                <div className="flex flex-wrap items-center gap-2 text-xs">
                  <span className="inline-flex items-center rounded-sm bg-primary-100 px-1.5 py-0.5 font-medium text-primary-700">
                    {item.category}
                  </span>
                  <span className="inline-flex items-center gap-1 text-accent-700">
                    <i className="ri-fire-line"></i>
                    {item.heat}
                  </span>
                  <span className="text-foreground-400">{item.time}</span>
                  <span className="ml-auto hidden items-center gap-1 rounded-sm border border-accent-200 px-1.5 py-0.5 text-accent-800 sm:inline-flex">
                    {item.tag}
                  </span>
                </div>
                <h4 className="font-heading mt-2 text-[17px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                  {item.title}
                </h4>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {item.excerpt}
                </p>
                <a
                  href="#contact"
                  className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 opacity-0 transition-opacity group-hover:opacity-100"
                >
                  有话说或相关线索？
                  <i className="ri-arrow-right-line"></i>
                </a>
              </article>
            ))}
          </div>

          <aside className="w-full shrink-0 lg:w-[300px]">
            <div className="rounded-lg bg-accent-500 p-5">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-foreground-950/10 text-foreground-950">
                <i className="ri-megaphone-line text-xl"></i>
              </span>
              <h4 className="font-heading mt-3 text-lg font-bold text-foreground-950">
                手里有独家线索？
              </h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-900/80">
                私信投稿或填写表单提交，编辑部核实后将第一时间跟进报道。
              </p>
              <a
                href="#contact"
                className="mt-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-900"
              >
                <i className="ri-send-plane-line"></i>
                立即投稿
              </a>
            </div>
            <div className="mt-4 rounded-lg border border-background-200 bg-background-100 p-5">
              <h4 className="flex items-center gap-2 text-sm font-semibold text-foreground-950">
                <i className="ri-chat-smile-3-line text-primary-600"></i>
                今日关注热度
              </h4>
              <p className="mt-3 text-3xl font-bold text-foreground-950">
                8.6<span className="text-base text-foreground-500"> 万+</span>
              </p>
              <p className="mt-1 text-xs text-foreground-500">
                全网线索参与与话题讨论量
              </p>
            </div>
          </aside>
        </div>

        {items.length > visible && (
          <div className="mt-8 text-center">
            <button
              type="button"
              onClick={() => setVisible((v) => v + 6)}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-200 bg-background-50 px-6 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-50"
            >
              <i className="ri-arrow-down-s-line"></i>
              加载更多内容
            </button>
          </div>
        )}
      </div>
    </section>
  );
}